export default __webpack_public_path__ + "static/media/checkbox-unselected.03e66f48.svg";